import { getRecipeQL } from '@libs/search-service-smart-search';
import type { ItinerarySearchUserCriteria } from '@libs/trip-planner-interfaces';
import {
  IngredientTypeQL,
  SelectedHotelTypeQL,
} from '@libs/trip-planner-interfaces';
import { isDefined } from '@libs/utils';

export function getRecipeForShareWidget(
  userCriteria: ItinerarySearchUserCriteria,
  affiliateId: string | undefined
): string {
  const recipe = getRecipeQL(
    {
      userCriteria,
      businessCriteria: {
        affiliateId,
      },
    },
    undefined
  );

  delete recipe.sessionId;
  delete recipe.metadata;

  recipe.ingredients = recipe.ingredients?.map((ingredient) => {
    if (ingredient?.ingredientType === IngredientTypeQL.Hotel) {
      delete ingredient.numberOfSuggestions;
      if (
        !isDefined(ingredient.selectedHotelTypes) ||
        hasAllHotelTypesSelected(
          ingredient.selectedHotelTypes.filter(isDefined)
        )
      ) {
        ingredient.selectedHotelTypes = [];
      }
    }

    return ingredient;
  });

  return JSON.stringify({
    recipe,
  });
}

function hasAllHotelTypesSelected(
  selectedHotelTypes: SelectedHotelTypeQL[]
): boolean {
  const hotelTypesAmount = 3;
  return (
    selectedHotelTypes.includes(SelectedHotelTypeQL.Hotel) &&
    selectedHotelTypes.includes(SelectedHotelTypeQL.Apartment) &&
    selectedHotelTypes.includes(SelectedHotelTypeQL.HouseOrCottage) &&
    selectedHotelTypes.length === hotelTypesAmount
  );
}
